import { DEFAULT_AUTOMIGRATE_COMMAND_LIST } from 'client/const/migrate-consts'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import ServerPage from 'server/types/ServerPageInterface'
import migrateBlogContentPlaceholderCommand from 'tools/commands/migrate/BlogContentPlaceholder/migrateBlogContentPlaceholderCommand'
import migrateBlogLatestPostsCommand from 'tools/commands/migrate/BlogLatestPosts/migrateBlogLatestPostsCommand'
import migrateBlogPageBodyCommand from 'tools/commands/migrate/BlogPageBody/migrateBlogPageBodyCommand'
import migrateBlogPostCategoriesCommand from 'tools/commands/migrate/BlogPostCategories/migrateBlogPostCategoriesCommand'
import migrateBlogPostContentPlaceholderCommand from 'tools/commands/migrate/BlogPostContentPlaceholder/migrateBlogPostContentPlaceholderCommand'
import migrateBlogPostLayoutBodyCommand from 'tools/commands/migrate/BlogPostLayoutBody/migrateBlogPostLayoutBodyCommand'
import migrateBlogPostLIstingCommand from 'tools/commands/migrate/BlogPostListing/migrateBlogPostLIstingCommand'
import migrateInlineCommand from 'tools/commands/migrate/Inline/migrateInlineCommand'
import migrateBlogPostBodyCommand from 'tools/commands/migrate/blog-post-body/migrate-blog-post-body-command'
import migrateFullTwoStepPaymentFormCommand from 'tools/commands/migrate/two-step-payment-form/migrate-full-two-step-payment-form-command'
import { removeDuplicatedBlogPostLayoutBody } from 'tools/commands/remove-duplicated-blog-post-layout-body'

const migratePage = (page: ServerPage): ServerPage => {
  const commandList = DEFAULT_AUTOMIGRATE_COMMAND_LIST

  switch (page.type) {
    case PageTypeEnum.BlogHome:
    case PageTypeEnum.BlogPostBody:
    case PageTypeEnum.BlogPostLayout:
    case PageTypeEnum.BlogPostListing:
    case PageTypeEnum.BlogStatic:
    case PageTypeEnum.BlogSearch:
      commandList.push(
        migrateBlogLatestPostsCommand,
        migrateBlogPostLIstingCommand,
        migrateBlogContentPlaceholderCommand,
        migrateBlogPostCategoriesCommand,
        migrateBlogPostContentPlaceholderCommand,
        migrateBlogPageBodyCommand,
        migrateBlogPostBodyCommand,
        migrateBlogPostLayoutBodyCommand,
        removeDuplicatedBlogPostLayoutBody,
      )
      break
    case PageTypeEnum.OfferPage:
    case PageTypeEnum.OfferDownSellPage:
    case PageTypeEnum.OfferInner:
      commandList.push(migrateFullTwoStepPaymentFormCommand)
      break
    case PageTypeEnum.Inline:
      commandList.push(migrateInlineCommand)
      break
  }

  return commandList.reduce((page, command) => command(page)[0], page)
}

export default migratePage
